import { lazy, Suspense } from 'react'
import Loader from '../custom/loader/main';


const Main = lazy(() => import('../components/setup/courses/main'));

const Courses = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  )
}

export default Courses;